import api from './api';
import { readList } from './listResponse';

const withStore = (storeId, config = {}) => ({ ...config, _storeId: storeId });

const normalizeSupplier = (supplier) => ({
  id: supplier?.id ?? supplier?.Id,
  name: supplier?.name ?? supplier?.Name ?? '',
  taxId: supplier?.taxId ?? supplier?.TaxId ?? '',
  phone: supplier?.phone ?? supplier?.Phone ?? '',
  email: supplier?.email ?? supplier?.Email ?? '',
  notes: supplier?.notes ?? supplier?.Notes ?? '',
  isArchived: Boolean(supplier?.isArchived ?? supplier?.IsArchived),
});

const SupplierService = {
  getSuppliers: async (storeId, { includeArchived = false } = {}) => {
    const response = await api.get('/suppliers', withStore(storeId, {
      params: { includeArchived },
    }));
    return readList(response.data).items.map(normalizeSupplier);
  },

  createSupplier: async (storeId, supplier) => {
    const response = await api.post('/suppliers', {
      name: String(supplier.name || '').trim(),
      taxId: supplier.taxId?.trim() || null,
      phone: supplier.phone?.trim() || null,
      email: supplier.email?.trim() || null,
      notes: supplier.notes?.trim() || null,
    }, withStore(storeId));
    return normalizeSupplier(response.data);
  },

  updateSupplier: async (storeId, supplierId, supplier) => {
    const response = await api.put(`/suppliers/${supplierId}`, {
      name: String(supplier.name || '').trim(),
      taxId: supplier.taxId?.trim() || null,
      phone: supplier.phone?.trim() || null,
      email: supplier.email?.trim() || null,
      notes: supplier.notes?.trim() || null,
    }, withStore(storeId));
    return normalizeSupplier(response.data);
  },

  archiveSupplier: async (storeId, supplierId) => {
    await api.delete(`/suppliers/${supplierId}`, withStore(storeId));
  },
};

export default SupplierService;
